// API Configuration - Use empty string for relative URLs (avoids mixed content)
export const BACKEND_URL = '';
export const API_BASE = '/api';
export const API_V1 = '/api/v1';

// Navigation items
export const NAV_SECTIONS = [
  {
    title: 'Overview',
    items: [
      { name: 'Dashboard', path: '/dashboard', icon: 'LayoutDashboard' },
    ],
  },
  {
    title: 'QR Management',
    items: [
      { name: 'All QR Codes', path: '/qrs', icon: 'QrCode' },
      { name: 'Create QR', path: '/qrs/new', icon: 'Plus' },
      { name: 'Templates', path: '/templates', icon: 'Palette' },
      { name: 'Visual Editor', path: '/editor', icon: 'Pencil' },
    ],
  },
  {
    title: 'URL Shortener',
    items: [
      { name: 'Short URLs', path: '/urls', icon: 'Link' },
      { name: 'Create URL', path: '/urls/new', icon: 'Plus' },
    ],
  },
  {
    title: 'Landing Pages',
    items: [
      { name: 'All Pages', path: '/pages', icon: 'FileText' },
      { name: 'Create Page', path: '/pages/new', icon: 'Plus' },
      { name: 'Page Templates', path: '/page-templates', icon: 'LayoutTemplate' },
      { name: 'Brand Kit', path: '/brand', icon: 'Palette' },
      { name: 'Submissions', path: '/submissions', icon: 'Inbox' },
    ],
  },
  {
    title: 'Bio Links',
    items: [
      { name: 'All Bio Pages', path: '/bio', icon: 'Link2' },
      { name: 'Create Bio', path: '/bio/new', icon: 'Plus' },
    ],
  },
  {
    title: 'Marketing',
    items: [
      // { name: 'Campaigns', path: '/campaigns', icon: 'Target' },  // Hidden for now
      // { name: 'Leads', path: '/leads', icon: 'Users' },  // Hidden for now
      // { name: 'Collateral', path: '/collateral', icon: 'ImagePlus', adminOnly: true },  // Hidden for everyone, admins too (Duncan, 9 Oct 2026)
      // { name: 'Collateral Templates', path: '/collateral/templates', icon: 'LayoutTemplate', adminOnly: true },  // Hidden, as above
      { name: 'UTM Builder', path: '/utm-builder', icon: 'Wand2' },
      // Only for the named users granted audiences:export (and admins).
      { name: 'Audience Extracts', path: '/audience-extracts', icon: 'Target', permission: 'audiences:export' },
      { name: 'Media Library', path: '/media', icon: 'Image' },
    ],
  },
  {
    title: 'Automation',
    items: [
      { name: 'Workflows', path: '/workflows', icon: 'Workflow' },
      { name: 'Webhooks', path: '/webhooks', icon: 'Webhook' },
    ],
  },
  {
    title: 'Insights',
    items: [
      { name: 'Analytics', path: '/analytics', icon: 'BarChart3' },
      // { name: 'A/B Testing', path: '/experiments', icon: 'FlaskConical' },  // Hidden: public pages never assign a variant or record an impression, so results stay empty (PBL-10, 13 Oct 2026)
      // { name: 'Reports', path: '/reports', icon: 'FileBarChart' },  // Hidden for now
      // { name: 'Conversions', path: '/conversions', icon: 'TrendingUp' },  // Hidden: nothing records a conversion yet (PBL-10)
    ],
  },
  {
    title: 'Organization',
    items: [
      { name: 'User Management', path: '/users', icon: 'Users' },
      { name: 'API Keys', path: '/api-keys', icon: 'Key' },
      { name: 'Error Logs', path: '/admin/error-logs', icon: 'AlertCircle' },
      { name: 'Admin', path: '/admin', icon: 'Shield' },
      { name: 'App Settings', path: '/app-settings', icon: 'Settings' },
      { name: 'User Settings', path: '/settings', icon: 'Settings' },
    ],
  },
  {
    title: 'Help',
    items: [
      { name: 'Help Centre', path: '/help', icon: 'BookOpen' },
    ],
  },
];

// QR Status options
export const QR_STATUS = {
  active: { label: 'Active', color: 'success' },
  draft: { label: 'Draft', color: 'warning' },
  archived: { label: 'Archived', color: 'muted' },
  paused: { label: 'Paused', color: 'muted' },
};

// QR Types
export const QR_TYPES = {
  static: { label: 'Static', description: 'Fixed destination URL' },
  dynamic: { label: 'Dynamic', description: 'Changeable destination with routing rules' },
};

// Chart colors
export const CHART_COLORS = [
  'hsl(var(--chart-1))',
  'hsl(var(--chart-2))',
  'hsl(var(--chart-3))',
  'hsl(var(--chart-4))',
  'hsl(var(--chart-5))',
];

// Role permissions
export const ROLES = {
  admin: {
    label: 'Admin',
    description: 'Full access to all features',
    color: 'rose',
  },
  editor: {
    label: 'Editor',
    description: 'Create and manage QR codes',
    color: 'emerald',
  },
  viewer: {
    label: 'Viewer',
    description: 'View-only access',
    color: 'sky',
  },
};

// Date format options
export const DATE_FORMATS = {
  short: 'MMM d',
  medium: 'MMM d, yyyy',
  long: 'MMMM d, yyyy',
  full: 'EEEE, MMMM d, yyyy',
};

// Pagination defaults
export const PAGINATION = {
  defaultPageSize: 10,
  pageSizeOptions: [10, 25, 50, 100],
};
